import _ from 'lodash';
import { translate } from '../../../../scripts/core/tools/translate';
import api from '../../../../scripts/api';
import environment from '../../../../scripts/environment';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class NewGreenfieldFilterFactory {
    constructor ({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData () {
        const data = [];

        data.push({
            name: 'tier',
            position: 1,
            visible: isAuthorized(FeaturePermission.LAYER_NEW_GREENFIELD.filterType),
            fields: [{
                title: translate('Greenfield.TierType'),
                name: 'IdPointTier',
                dataSource: environment.get('CONFIG.FILTERS.GREENFIELD_POINT_TIERS'),
                value: 'id',
                text: 'name',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        data.push({
            name: 'storeType',
            position: 2,
            visible: isAuthorized(FeaturePermission.LAYER_NEW_GREENFIELD.filterType),
            fields: [{
                title: translate('Greenfield.StoreType'),
                name: 'IdPointType',
                dataSource: environment.get('CONFIG.FILTERS.GREENFIELD_POINT_TYPES'),
                value: 'id',
                text: 'name',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        return data.filter(c => c.visible);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/newGreenfield.factory.js